<div class="playlistWrapper {{isChecked?'checked':''}}" (click)="onShowDetails()">
  <tun-checkbox-v5 *ngIf="isChecked" [isChecked]="true" [checkBoxColor]="TunifyCheckBoxColor.white" class="checkbox" ></tun-checkbox-v5>
  <div class="playlistTitleContainer">
    <tun-scrollable-text class="playlistTitle" [text]="playlist.title"></tun-scrollable-text>
  </div>
</div>
